import React, { Component } from "react";

require("../assets/css/style.css");
class SearchNoResult extends Component {
  constructor(props) {
    super(props);
  }

  handleDateChange() {
    this.setState({
      date: !this.state.date,
    });
  }

  render() {
    const _this = this;
    const { open, yesClick, noClick, stylec } = this.props;
    const st = {
      width: stylec
    };
    return (
      <div>
        <img src={require("../assets/images/404.png")} style={st}/>
      </div>
    );
  }
}

export default SearchNoResult;
